/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uImageAlbum = A4uImageAlbum;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uImageAlbum(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("circle", {
    fillRule: "evenodd",
    cx: "26.5",
    cy: "13.5",
    r: "2.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M33,6H3A1,1,0,0,0,2,7v3H1a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H2v8H1a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H2v3a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V7A1,1,0,0,0,33,6ZM6,25a1,1,0,0,1-1,1H4V22H5a1,1,0,0,1,1,1ZM6,13a1,1,0,0,1-1,1H4V10H5a1,1,0,0,1,1,1ZM32,25.748l-4.519-4.519a1.713,1.713,0,0,0-2.424,0l-2.633,2.632-6.476-6.477a1.716,1.716,0,0,0-2.425,0L8,22.908V8H32Z"
  }));
}